import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { Card, Container, Row, Col } from 'react-bootstrap';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import StripePaymentForm from '../components/Payment/StripePaymentForm';
import Header from '../components/Layout/Header';

// Charger la clé publique Stripe depuis les variables d'environnement
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK);

const PaymentPage = () => {
  const location = useLocation();
  const history = useHistory();
  const { orderData, totalTTC } = location.state || {};

  // Rediriger si pas de données de commande
  if (!orderData || !totalTTC) {
    history.push('/commande');
    return null;
  }

  return (
    <>
      <Header />
      <Container className="py-5">
        <Row className="justify-content-center">
          <Col lg={8}>
            <h2 className="mb-4 text-center">Finaliser le paiement</h2>

            <Card className="mb-4 shadow-sm">
              <Card.Body>
                <Card.Title className="mb-3">Récapitulatif de la commande</Card.Title>

                <table className="table table-borderless">
                  <tbody>
                    <tr>
                      <td><strong>Adresse de ramassage:</strong></td>
                      <td>{orderData.adressPickUp}</td>
                    </tr>
                    <tr>
                      <td><strong>Adresse de livraison:</strong></td>
                      <td>{orderData.adresseLivraison}</td>
                    </tr>
                    <tr>
                      <td><strong>Poids:</strong></td>
                      <td>{orderData.poidsLabel}</td>
                    </tr>
                    <tr>
                      <td><strong>Type de livraison:</strong></td>
                      <td className="text-capitalize">{orderData.livraisonType}</td>
                    </tr>
                    {orderData.dateLivraison && (
                      <tr>
                        <td><strong>Date de livraison:</strong></td>
                        <td>{orderData.dateLivraison}</td>
                      </tr>
                    )}
                    <tr>
                      <td><strong>Client:</strong></td>
                      <td>{orderData.prenomClient} {orderData.nomClient}</td>
                    </tr>
                  </tbody>
                </table>

                <hr />

                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span>Total HT:</span>
                  <strong>{orderData.totalHT} €</strong>
                </div>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <span className="h5 mb-0">Total TTC:</span>
                  <strong className="h5 mb-0 text-success">{totalTTC.toFixed(2)} €</strong>
                </div>
              </Card.Body>
            </Card>

            <Card className="shadow-sm">
              <Card.Body>
                <Elements stripe={stripePromise}>
                  <StripePaymentForm orderData={orderData} totalTTC={totalTTC} />
                </Elements>
              </Card.Body>
            </Card>

            <div className="text-center mt-3">
              <button
                className="btn btn-link"
                onClick={() => history.push('/commande')}
              >
                Retour au formulaire
              </button>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default PaymentPage;
